// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
// containers
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';

function FruitForm(props) {
  const { t } = useTranslation();
  return (
    <Dialog
      fullWidth
      onClose={props.toggleForm}
      aria-labelledby="simple-dialog-title"
      open={props.isOpen}>
      <DialogTitle>{t(props.edit ? 'Edit species' : 'Create species')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.name}
              onChange={props.changeControls}
              fullWidth
              id="name"
              label={t('Name')}
              error={props.invalidControls.name}
              helperText={props.invalidControls.name && t('Name required')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.toggleForm} color="primary">
          {t('Cancel')}
        </Button>
        <ButtonWithLoader onClick={props.submit} autoFocus buttonId="create-edit-fruit">
          {t(props.edit ? 'Edit' : 'Add')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default FruitForm;
